var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-animation"},[_c('transition',{attrs:{"name":"bounce","appear":""}},[_c('Logo',{staticClass:"logo"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }